// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".action-img[data-v-2ac4879a]{max-height:250px}.desc[data-v-2ac4879a]{white-space:pre-wrap}.action-icon[data-v-2ac4879a]{max-width:2em;margin-bottom:.5em}", ""]);
// Exports
module.exports = exports;
